<script>
import PhCalendar from './PhCalendar.vue';
import PhCube from './PhCube.vue';
import PhIdentificationCard from './PhIdentificationCard.vue';
import PhKanban from './PhKanban.vue';
import PhMoney from './PhMoney.vue';
import PhPhone from './PhPhone.vue';
import PhRobot from './PhRobot.vue';
import PhUsersFour from './PhUsersFour.vue';

export default {
  components: {
    PhMoney,
    PhUsersFour,
    PhKanban,
    PhIdentificationCard,
    PhCalendar,
    PhCube,
    PhRobot,
  },
  computed: {
    navigation() {
      const currentInstance = this;
      function hasPermission(permission) {
        return currentInstance.$membershipHasPermissionTo(permission);
      }
      function isAdminOrSuperAdmin() {
        return currentInstance.$isAdminOrSuperAdmin;
      }

      const accountId = this.$currentAccount.id;

      const items = [
        {
          items: [
            {
              name: 'Διαθέσιμα αιτήματα',
              href: `/c/${accountId}/marketplace/listings`,
              icon: PhUsersFour,
              show: () => hasPermission('read contact request listings'),
            },
            {
              name: 'Διαχείρηση αιτημάτων',
              href: `/c/${accountId}/pipelines`,
              icon: PhKanban,
              show: () => hasPermission('read pipelines'),
            },
            {
              name: 'Τα αιτήματά μου',
              href: `/c/${accountId}/contact-requests`,
              icon: PhIdentificationCard,
              show: () => hasPermission('read contact requests'),
            },
            {
              name: 'Ημερολόγιο',
              href: `/c/${accountId}/calendar`,
              icon: PhCalendar,
            },
            {
              name: 'Κλήσεις',
              href: `/c/${accountId}/calls`,
              icon: PhPhone,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Συναλλαγές',
              href: `/c/${accountId}/marketplace/transactions`,
              icon: PhMoney,
              show: () => hasPermission('read transactions'),
            },
            {
              name: 'Προϊόντα',
              href: `/c/${accountId}/acc-products`,
              icon: PhCube,
              show: () => hasPermission('read acc products'),
            },
            {
              name: 'Αυτοματισμοί',
              href: `/c/${accountId}/automations`,
              icon: PhRobot,
              show: () => hasPermission('read automations'),
            },
            // {
            //   name: 'Ρυθμίσεις marketplace',
            //   to: { name: 'clients.marketplace.settings' },
            //   // icon: h(PhGear),
            //   show: () => isAdmin() || isSuperAdmin(),
            // },
          ],
        },
      ];

      return items;
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-full flex-1 bg-gray-900">
    <div class="flex-1 flex flex-col pb-4 overflow-y-auto pt-8">
      <RouterLink
        v-if="$currentAccount.logo"
        :to="{ name: 'accounts.show', params: { accountId: $currentAccount.id } }"
      >
        <img :src="$currentAccount.logo" class="block rounded w-24 mb-8 mx-auto" />
      </RouterLink>
      <h6 class="text-center text-white mb-6">
        {{ $currentAccount.name }}
      </h6>
      <div class="px-6">
        <nav class="flex flex-1 flex-col">
          <ul role="list" class="flex flex-1 flex-col gap-y-7">
            <li v-for="(group, groupIdx) in navigation" :key="groupIdx">
              <div v-if="group.name" class="text-xs font-semibold leading-6 text-gray-400">
                {{ group.name }}
              </div>
              <ul role="list" class="-mx-2 space-y-1">
                <template v-for="item in group.items">
                  <li v-if="(item.show || (() => true))()" :key="item.name">
                    <RouterLink
                      v-if="item.to"
                      :to="item.to"
                      custom
                      v-slot="{ isActive, isExactActive, href, navigate }"
                    >
                      <a
                        :href="href"
                        :class="[
                          (item.exact ? isExactActive : isActive)
                            ? 'bg-gray-800 text-white'
                            : 'text-gray-400 hover:text-white hover:bg-gray-800',
                          'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold transition-colors',
                        ]"
                        @click="navigate"
                      >
                        <component
                          v-if="item.icon"
                          :is="item.icon"
                          class="h-6 w-6 shrink-0"
                          aria-hidden="true"
                        />
                        {{ item.name }}
                      </a>
                    </RouterLink>
                    <a
                      v-if="item.href"
                      :href="item.href"
                      :class="[
                        'text-gray-400 hover:text-white hover:bg-gray-800 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold transition-colors',
                      ]"
                    >
                      <component
                        v-if="item.icon"
                        :is="item.icon"
                        class="h-6 w-6 shrink-0"
                        aria-hidden="true"
                      />
                      {{ item.name }}
                    </a>
                  </li>
                </template>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>
